module.exports = __webpack_public_path__ + "img/phenix-city.d5d429ff.jpg";